var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-loading',{staticClass:"fl-layout-loading",attrs:{"is-open":_vm.hasLoading,"size":"big","type":"global"}})
}
var staticRenderFns = []

export { render, staticRenderFns }